<div class="wrap">
  <div class="header">
    <div class="logo">
      <app-svg-icon
        [name]="'logo-small'"
        [color]="'color-surface'"
      ></app-svg-icon>
    </div>
    <div class="greeting">{{ "@pages.login.greeting" | translate }}</div>
    <div class="brand">Chill&Bite</div>
  </div>
  <div class="content">
    <div class="title">{{ "@pages.changePassword.title" | translate }}</div>
    <div class="form">
      <app-input
        [control]="form.controls.password"
        [iconName]="'lock'"
        [label]="'@pages.changePassword.form.password.label' | translate"
        [placeholder]="
          '@pages.changePassword.form.password.placeholder' | translate
        "
      ></app-input>
      <app-input
        [control]="form.controls.confirmPassword"
        [iconName]="'lock'"
        [label]="'@pages.changePassword.form.confirmPassword.label' | translate"
        [placeholder]="
          '@pages.changePassword.form.confirmPassword.placeholder' | translate
        "
      ></app-input>
      <div class="error-message" *ngIf="requestFailedWithError === true">
        {{ "@pages.changePassword.errorMessage" | translate }}
      </div>
    </div>
    <div class="action-btn mb">
      <app-action-button
        (click)="onResetPasswordClick()"
        [label]="'@pages.changePassword.actionBtn' | translate"
        [endIconName]="'arrow-right'"
        [disabled]="form.invalid || form.pristine"
        [isLoading]="(loader.isLoading$ | async)!"
      ></app-action-button>
      <app-action-button
        (click)="onCancelClick()"
        [label]="'@pages.changePassword.cancel' | translate"
        [isOutlined]="true"
      ></app-action-button>
    </div>
  </div>
</div>
